import React from "react";
import { Link } from "react-router-dom";
import PublicInfoLayout from "./PublicInfoLayout";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Privacidad: no conectamos con tu banco | Ahorra y respira",
  url: "https://ahorrayrespira.com/privacidad-sin-conexion-banco",
  description: "Cómo se tratan los datos en la app y por qué mantienes el control sin conexión bancaria automática.",
  inLanguage: "es-ES",
};

export default function PrivacyNoBankConnectionPage() {
  return (
    <PublicInfoLayout
      title="Privacidad: no conectamos con tu banco"
      subtitle="Cómo tratamos tus datos y por qué mantienes tú el control en todo momento."
      updatedAt="18 de febrero de 2026"
      canonicalPath="/privacidad-sin-conexion-banco"
      structuredData={structuredData}
    >
      <section className="panel">
        <h2 className="panel-title">Modelo de datos</h2>
        <p>
          Ahorra y respira trabaja con archivos que tú decides subir (extractos CSV/XLSX). No existe conexión automática con
          tu banco ni acceso en tiempo real a tus cuentas.
        </p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Qué control tienes tú</h2>
        <ul className="landing-list" style={{ marginTop: "0.5rem" }}>
          <li>Nadie, absolutamente nadie excepto tú puede acceder a tus datos.</li>
          <li>Decides qué archivos subes y cuándo.</li>
          <li>Puedes editar, corregir o eliminar datos cargados.</li>
          <li>Puedes realizar un borrado total desde tu área privada.</li>
        </ul>
      </section>

      <section className="panel">
        <h2 className="panel-title">Información legal y cookies</h2>
        <p>Si quieres detalle legal completo, revisa estas páginas públicas:</p>
        <ul className="landing-list" style={{ marginTop: "0.5rem" }}>
          <li><Link to="/legal/aviso-legal">Aviso legal</Link></li>
          <li><Link to="/legal/privacidad-cookies">Privacidad y cookies</Link></li>
          <li><Link to="/legal/terminos-suscripcion">Términos y suscripción</Link></li>
        </ul>
      </section>
    </PublicInfoLayout>
  );
}
